import React from 'react';
import { Grid, Loader, Table } from 'semantic-ui/semantic-ui-imports';
import { ResultSet } from 'services/results';
import './index.scss';

interface Props {
  data: ResultSet | undefined;
}

function AudioCalculations({ data }: Props) {
  if (!data) {
    return <Loader />;
  }

  return (
    <div className="audio-calculations">
      <Grid>
        <Grid.GridRow>
          <h2 className="audio-calculations__header">{data.title}</h2>
        </Grid.GridRow>
        {data.airVolumes.map((item: string, i: number) => (
          <React.Fragment key={`data-description-${i}`}>
            <Grid.GridRow>
              <p>{item}</p>
            </Grid.GridRow>
          </React.Fragment>
        ))}
        <Grid.GridRow>
          <h3 className="audio-calculations__subheader1">{data.subTitle}</h3>
        </Grid.GridRow>
        <Grid.GridRow>
          <p>{data.table.dataDescription.title}</p>
        </Grid.GridRow>
      </Grid>

      <Table textAlign="center" className="audio-calculations__table">
        <Table.Header>
          <Table.Row>
            {data.table.data.map(
              (item: { name: string; values: number[] }, idx: number) =>
                !!item?.name && (
                  <React.Fragment key={item.name + idx}>
                    <Table.HeaderCell>{item.name}</Table.HeaderCell>
                  </React.Fragment>
                )
            )}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {data.table.data.map(
            (row: { name: string; values: number[] }, i: number) => (
              <React.Fragment key={`audio_row_${i}}`}>
                <Table.Row>
                  {!!data.table.data[i]?.values?.length &&
                    data.table.data[i].values.map((col: number, j: number) => (
                      <React.Fragment key={`factor_${j}`}>
                        <Table.Cell>{col}</Table.Cell>
                      </React.Fragment>
                    ))}
                </Table.Row>
              </React.Fragment>
            )
          )}
        </Table.Body>
      </Table>

      <Grid>
        <Grid.GridRow>
          <p>{data.tableClean.dataDescription.title}</p>
        </Grid.GridRow>
      </Grid>

      {/* <Table textAlign="center" className="audio-calculations__table">
        <Table.Header>
          <Table.Row>
            {data.tableClean.data.map(
              (item: { name: string; values: number[] }, idx: number) =>
                !!item?.name && (
                  <React.Fragment key={item.name + idx}>
                    <Table.HeaderCell>{item.name}</Table.HeaderCell>
                  </React.Fragment>
                )
            )}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {data.tableClean.data.map(
            (row: { name: string; values: number[] }, i: number) => (
              <React.Fragment key={`audio_row_${i}}`}>
                <Table.Row>
                  {!!data.tableClean.data[i]?.values?.length &&
                    data.tableClean.data[i].values.map(
                      (col: number, j: number) => (
                        <React.Fragment key={`factor_${j}`}>
                          <Table.Cell>{col}</Table.Cell>
                        </React.Fragment>
                      )
                    )}
                </Table.Row>
              </React.Fragment>
            )
          )}
        </Table.Body>
      </Table> */}
    </div>
  );
}

export default AudioCalculations;
